import { TextSeeMoreComponent } from './text-see-more.component';

export default angular
  .module('sfMobile.components.text-see-more', [])
  .component('sfTextSeeMore', TextSeeMoreComponent).name;
